export type FeatureFlagValue = {
  enabled: boolean
} & Record<string, unknown>

const FEATURE_FLAG_API_URL = process.env.REACT_APP_FEATURE_FLAG_API_URL
const FEATURE_FLAG_API_KEY = process.env.REACT_APP_FEATURE_FLAG_API_KEY

const fetchFlag = async (flagKey: string): Promise<FeatureFlagValue | null> => {
  try {
    const response = await fetch(FEATURE_FLAG_API_URL + `/${flagKey}`, {
      headers: {
        'x-api-key': FEATURE_FLAG_API_KEY,
      },
    })

    if (!response.ok) {
      console.error(`Failed to fetch feature flag ${flagKey}`)
      return null
    }

    const body = await response.json()
    return body.value as FeatureFlagValue
  } catch (error) {
    console.error(`Failed to fetch feature flag ${flagKey}`, error)
    return null
  }
}

export const fetchFeatureFlagStatus = async (flagKey: string, defaultValue = false): Promise<FeatureFlagValue> => {
  try {
    const flagValue = await fetchFlag(flagKey)

    if (flagValue && typeof flagValue.enabled === 'boolean') {
      return flagValue
    }

    return { enabled: defaultValue }
  } catch (error) {
    console.error(`Failed to fetch feature flag ${flagKey}, using default value ${defaultValue}`, error)
    return { enabled: defaultValue }
  }
}
